import { T } from 'gt-react';
import type { TaskTypeEditorState } from './taskTypeAdmin';
import { NO_INPUT_SCHEMA_VALUE } from './taskTypeAdmin';
import { useGetSchemaDefinition } from 'src/api/rpc/hooks/core/useSchemaDefinitions';
import { TaskTypeSection } from './TaskTypeEditorSections';
import { TaskTypeViewBuilder } from './TaskTypeViewBuilder';
import {
  resolveViewSchemaSource,
  type ViewSchemaSource,
} from './taskTypeViewModel';

export function TaskTypeViewSection({
  editor,
  disabled,
  onViewTextChange,
}: {
  editor: TaskTypeEditorState;
  disabled?: boolean;
  onViewTextChange: (viewText: string) => void;
}) {
  const schema = useTaskTypeViewFields(editor);

  return (
    <TaskTypeSection
      title={<T context="task type editor section title">Task page</T>}
      description={
        <T context="task type editor task page section description">
          What a person sees when they open a task of this type. Add sections
          (Main stacks left, Side stays beside it), then place fields, an email,
          document, AP invoice, or cash receipt viewer, and Supplier Lines for
          rows from Match Supplier Document Lines. Field placements read the
          input schema. The viewers can also render the task anchor.
        </T>
      }
    >
      <TaskTypeViewBuilder
        viewText={editor.viewText}
        schema={schema}
        disabled={disabled}
        onChange={onViewTextChange}
      />
    </TaskTypeSection>
  );
}

function useTaskTypeViewFields(editor: TaskTypeEditorState): ViewSchemaSource {
  const selected = editor.inputSchemaDefinitionId;
  const saved = editor.editing?.inputSchema ?? null;
  const shouldFetch =
    selected !== NO_INPUT_SCHEMA_VALUE && saved?.id !== selected;
  const query = useGetSchemaDefinition(shouldFetch ? selected : '');
  return resolveViewSchemaSource({
    selectedId: selected,
    noneId: NO_INPUT_SCHEMA_VALUE,
    saved,
    fetched: query.data ?? null,
    fetchFailed: query.isError,
  });
}
